//
// This module contains all methods that handle communication between
// the React/Redux application and the JSAPI map
//

import { loadModules } from 'esri-loader';

//* **************
// LayerManager
//* **************

export function fetchIncidentById(id, options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-incident-by-id',
        id,
        options,
        resolve,
        reject
      );
    });
  });
}

export function fetchIncidents(options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/fetch-incidents', options, resolve, reject);
    });
  });
}

export function fetchManyIncidents(options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-many-incidents',
        options,
        resolve,
        reject
      );
    });
  });
}

export function fetchIncidentCount() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/fetch-incident-count', resolve, reject);
    });
  });
}

export function fetchIncidentHistory(options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-incident-history',
        options,
        resolve,
        reject
      );
    });
  });
}

export function fetchResources209(options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-incident-209-resources',
        options,
        resolve,
        reject
      );
    });
  });
}

/**
 * @func fetchResourcesByIncidentID
 * @desc Returns a promise that publishes a topic with the
 *       associated message to fetch the resou
 *
 * @param {Object} options
 * @param {string} option.where The where clause.
 * @returns {Promise}
 */
export function fetchResourcesByIncidentID(incidentID) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-resources-by-incident-id',
        incidentID,
        resolve,
        reject
      );
    });
  });
}

export function fetchRequestsByIncidentID(incidentID) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-requests-by-incident-id',
        incidentID,
        resolve,
        reject
      );
    });
  });
}

export function fetchOperationalStatusesByIncidentID(incidentID) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-operational-statuses-by-incident-id',
        incidentID,
        resolve,
        reject
      );
    });
  });
}

export function fetchExperiencesByIncidentID(incidentID) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-experiences-by-incident-id',
        incidentID,
        resolve,
        reject
      );
    });
  });
}

export function fetchDispatchIDs() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/fetch-dispatch-ids', resolve, reject);
    });
  });
}

export function fetchCIDsByID() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/fetch-cids-by-ids', resolve, reject);
    });
  });
}

export function fetchCapabilitiesbyRequests(incidentID) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-capabilities-by-requests',
        incidentID,
        resolve,
        reject
      );
    });
  });
}

export function fetchCTIDs(incidentID) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-ctids',
        incidentID,
        resolve,
        reject
      );
    });
  });
}

export function fetchResourcesByCurrentDispatch(currentdispatch) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-resources-by-current-dispatch',
        currentdispatch,
        resolve,
        reject
      );
    });
  });
}
export function fetchRelationshipsByRID(ParentIrwinRID){
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-relationships-by-rid',
        ParentIrwinRID,
        resolve,
        reject
      );
    });
  });
}
export function fetchResourceRelationships(irwinID){
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-resource-relationships',
        irwinID,
        resolve,
        reject
      );
    });
  });
}

export function fetchResourceById(id) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/fetch-resource-by-id', id, resolve, reject);
    });
  });
}

export function fetchResourceInfoById(id, options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/fetch-resource-info-by-id', id, options, resolve, reject);
    });
  });
}

export function fetchResources(options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/fetch-resources', options, resolve, reject);
    });
  });
}
export function fetchResourceRequests(options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/fetch-resource-requests', options, resolve, reject);
    });
  });
}

export function fetchManyResources(options) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish(
        'LayerManager/fetch-many-resources',
        options,
        resolve,
        reject
      );
    });
  });
}

export function zoomToGeometry(geometry) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/zoom-to-geometry', geometry, resolve, reject);
    });
  });
}
export function zoomToManyGeometry(geometry) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then(([topic]) => {
      topic.publish('LayerManager/zoom-to-many-geometry', geometry, resolve, reject);
    });
  });
}






// WEBPACK FOOTER //
// ./src/esri/mapHub.js